module.exports = __webpack_public_path__ + "img/m4map.b3391055.png";